import { useState } from "react";
import { Popover } from "react-tiny-popover";
import Tooltip from "rc-tooltip";

import { DocumentActions } from "../../../../reflux/document_store";

import { Checkbox } from "../Checkbox";

const Realize = {
  i18n: window.Realize.i18n,
};

const notFoundErrors = [
  'document_not_found',
  'document_not_found_exception',
  'document_not_found_in_storage_exception'
]

export function ExportMultipleItem({ 
  document,
  error,
  onToggleSelectedDocument,
  isChecked
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const contentPopoverError = (error) => {
    const message = Realize.i18n.t(`exportMultipleModal.error.${error.code}`);
    const fallbackMessage = Realize.i18n.t('exportMultipleModal.error.unexpected_error');

    return (
      <div className='content-popover-error'>
				<ul>
					<li>{message || fallbackMessage}</li>
				</ul>
			</div>
    )
  }

  const handleViewDocument = () => {
    DocumentActions.previewDocumentFile(document.fileUuid);
  }

  const handleDownloadDocument = () => {
    DocumentActions.downloadDocumentFile(document.fieldName, {
      fileName: document.fileName,
      fileUUID: document.fileUuid
    });
  }

  const isDocumentErrorByNotFound = error && notFoundErrors.includes(error.code);

  return (
    <tr className='table-row'>
      <td>
        <div className='flex-center'>
          <Checkbox
            isChecked={isChecked}
            onChange={() => onToggleSelectedDocument(document.fileUuid)}
          />
        </div>
      </td>
      <td className='table-cell'>
        <div className='content-cell'>
          <Tooltip 
            placement="top"
            overlay={Realize.i18n.t('template.actions.previewDocument')} 
            showArrow={false}
          >
            <button 
              className='preview-button'
              type='button'
              onClick={handleViewDocument}
              disabled={!!isDocumentErrorByNotFound}
            >
              <i className='material-icons download-icon'>visibility</i>
            </button>
          </Tooltip>
          
          <Tooltip 
            placement="top"
            overlay={document.fileName} 
            showArrow={false}
          >
            {!!isDocumentErrorByNotFound ? (
              <span>{document.fileName}</span>
            ) : (
              <button 
                className='download-link-button ellipsis'
                type='button'
                onClick={handleDownloadDocument}
              >
                {document.fileName}
              </button>
            ) }
          </Tooltip>
        </div>
      </td>
      <td className='table-cell' >
        <div className='content-cell field-cell'>
          {document.fields.map((field) => (
            <Tooltip 
              placement="top"
              overlay={field.label ?? ''} 
              showArrow={false}
            >
              <span className='ellipsis'>{field.label ?? ''}</span>
            </Tooltip>
           ))}
        </div>
      </td>
      <td className="table-cell">
        {error && (
          <Popover 
            isOpen={isPopoverOpen}
            positions={['left']}
            content={contentPopoverError(error)}
          >
            <div 
              className="flex-center"
              onMouseOver={() => setIsPopoverOpen(true)}
              onMouseOut={() => setIsPopoverOpen(false)}
            >
              <i className='material-icons error-icon'>error_outline</i>
            </div>
          </Popover>
        )}
      </td>
    </tr>
  )
}